function submitUpSelling(event, cartEntryIndex, type) {
    event.preventDefault();

    var upsellingContainer = $(event.currentTarget).closest('.upselling-data-container');
    var upsellingProductDescription;
    var productDescriptionContainer = upsellingContainer.find('.upselling-product-description-text');

    if (productDescriptionContainer.is('input')) {
        upsellingProductDescription = productDescriptionContainer.val();
    } else {
        upsellingProductDescription = productDescriptionContainer.text().trim();
    }

    var data = {};
    data["cartEntryIndex"] = cartEntryIndex;

    if (upsellingProductDescription) {
        data["productDescription"] = upsellingProductDescription;
    }

    postCartData(data, '/submit/cart/' + type, event);
}

function engraveErrorMessage(response, upsellingContainer) {
    upsellingContainer.find(".upselling-engrave-error").show();
    upsellingContainer.find(".upselling-engrave-error span").text(response);
    upsellingContainer.find(".upselling-product-description-text").val("");
}

function engraveEmptyMessage(upsellingContainer) {
    upsellingContainer.find(".upselling-engrave-empty").show();
    upsellingContainer.find(".upselling-product-description-text").val("");
}

function resetMessages() {
    $(".upselling-engrave-error").hide();
    $(".upselling-engrave-empty").hide();
}

function submitTyreWithDot(event, tyreProductId) {
        var token = $("._csrf").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: "/dot/"+tyreProductId ,
            type: 'POST',
            beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
            },
            contentType: 'application/json; charset=utf-8',
            success: function (response) {
                document.location.href="/cart";
            },
            error: function (xhr, textStatus, errorThrown) {
                console.error("Unable to submit dot for product: "+tyreProductId+". Reason: "+xhr.responseText);
            }
        });
}

function displayInfoBox(data) {
    $.fancybox({
        width: 700,
        height: 300,
        content: data,
        fitToView: true,
        autoSize: false,
        helpers: {
            overlay: {
                locked: false
            }
        }
    });
}

function clearCheckboxState() {
    localStorage.removeItem('checkboxState');
}

var checkboxFunction = function () {
    var updateCheckboxState = function (isChecked) {
        localStorage.setItem('checkboxState', isChecked ? 'checked' : 'unchecked');
    };

    var getCheckboxState = function () {
        return localStorage.getItem('checkboxState') === 'checked';
    };

    var checkbox = $('#delivery-consent-checkout-container input[type="checkbox"]');
    var isChecked = getCheckboxState();
    checkbox.prop('checked', isChecked);

    $('#delivery-consent-checkout-container').click(function (e) {
        var checkbox = $(this).find('input[type="checkbox"]');
        checkbox.prop('checked', !checkbox.prop('checked'));
        updateCheckboxState(checkbox.prop('checked'));
    });

    $(checkbox).click(function (e) {
        e.stopPropagation();
        var isChecked = $(this).prop('checked');
        updateCheckboxState(isChecked);
    });

    $('#delivery-consent-checkout-container label').click(function (e) {
        var checkbox = $(this).prev('input[type="checkbox"]');
        checkbox.prop('checked', !checkbox.prop('checked'));
        e.stopPropagation();
        updateCheckboxState(checkbox.prop('checked'));
    });
}

$(document).ready(function () {
    checkboxFunction();
});
